import React from "react";

import Styled from "./index.styles";

export type TitleStyle = "default" | "section";

export default function BoardPageTitle({
  children,
  titleStyle,
  className,
}: {
  children: React.ReactNode;
  titleStyle: TitleStyle;
  className?: string;
}) {
  return (
    <Styled.container
      className={`${className ? className : ""} board-page-title`}
      titleStyle={titleStyle}
    >
      {children}
    </Styled.container>
  );
}
